// extracted by mini-css-extract-plugin
export default {"contentContainer":"customers-content_contentContainer__2G+2m"};